export class PqrTicketPersonEntity{

    id:number;
    description:string;
    active:boolean;
    userId:number;
    pqrTicketId:number;
    
    constructor (){}
}